import React, { useCallback } from 'react';
import { NumericFormat, NumericFormatProps, OnValueChange } from 'react-number-format';

import TextInput, { TextInputProps } from '../TextInput/TextInput';

export type NumberFormatInputProps = Omit<NumericFormatProps & TextInputProps, 'onChange'> & {
  onChange: (value: number | undefined) => void;
};

const NumberFormatInput = ({ onChange, ...props }: NumberFormatInputProps) => {
  const onValueChange: OnValueChange = useCallback(
    (values) => {
      onChange(values.floatValue);
    },
    [onChange],
  );

  return <NumericFormat customInput={TextInput} {...props} onValueChange={onValueChange} />;
};

export default NumberFormatInput;
